{
  "bool": 1,
  "float64": 8,
  "float32": 4,
  "int16": 2,
  "int32": 4,
  "int8": 1,
  "uint16": 2,
  "uint32": 4,
  "uint8": 1,
  "uint8c": 1,
  "complex64": 8,
  "complex128": 16
}
